import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';

import TabUpcomingEarnings 	from './components/TabUpcomingEarnings';
import TabRecentEarnings 	from './components/TabRecentEarnings';
import TabDividends			from './components/TabDividends';

function Calendar() {
	const [searchParams] = useSearchParams()
	const [tab, setTab] = useState(Number(searchParams.get('tab')) || 0)

	return (
		<Paper bgcolor="white" sx={{ marginLeft: 2, marginRight: 2 }}>
			<Box sx={{ p: 3 }}>
				<Typography variant="h5" fontWeight="bold" mb={2}>
					Calendário
				</Typography>

				<Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
					<Tabs value={tab} onChange={(_, v) => setTab(v)}>
						<Tab label="Próximos Balanços" />
						<Tab label="Últimos Balanços" />
						<Tab label="Dividendos" />
					</Tabs>
				</Box>

				{tab === 0 && <TabUpcomingEarnings />}
				{tab === 1 && <TabRecentEarnings />}
				{tab === 2 && <TabDividends />}
			</Box>
		</Paper>
	)
}

export default Calendar
